import App from './App.svelte';

const hicreoLoadingElement = document.body.querySelector('#hicreo-loading')

const app = new App({
  target: hicreoLoadingElement,
  props: {
    customClass: hicreoLoadingElement.getAttribute('class')
  }
});

export default app;
